import React, { useState, useEffect, Fragment } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Row, Col, Card, Button, Form } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import api from "../../../api";
import swal from "sweetalert";

const INDIAN_STATES = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

const VendorEdit = () => {
 const { id } = useParams();
 const navigate = useNavigate();
 const [loading, setLoading] = useState(false);
 const [fetching, setFetching] = useState(true);
 const [categories, setCategories] = useState([]);
// ===========================
// VALIDATION REGEX
// ===========================
const phoneRegex = /^\+?[1-9]\d{7,14}$/;
const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
const aadhaarRegex = /^[0-9]{12}$/;

const gstRegex =
 /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/;

const accountRegex = /^[0-9]{9,18}$/;

const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
 const [form, setForm] = useState({
 name: "",
 category: "",
 contactPerson: "",
 email: "",
 phone: "",
 address: "",
 state: "",
 gst: "",
 panNumber: "",
 aadhaarNumber: "",
 panDocument: null,
 aadhaarDocument: null,
 panDocumentFile: null,
 aadhaarDocumentFile: null,
 bank: {
 bankName: "",
 accountHolder: "",
 accountNo: "",
 confirmAccountNo: "",
 ifsc: "",
 },
 status: "Active",
 });

 const statuses = ["Active", "Inactive", "Blacklisted"];

 useEffect(() => {
 fetchVendor();
 fetchCategories();
 }, [id]);

 const fetchVendor = async () => {
 try {
 setFetching(true);
 const response = await api.get(`/vendors/${id}`);

 if (response.data.success) {
 const vendor = response.data.data;

 setForm({
 name: vendor.name || "",
 category: vendor.category?._id || "",
 contactPerson: vendor.contactPerson || "",
 email: vendor.email || "",
 phone: vendor.phone || "",
 address: vendor.address || "",
 state: vendor.state || "",

 gst: vendor.gst || "",
 panNumber: vendor.panNumber || "",
 aadhaarNumber: vendor.aadhaarNumber || "",
 panDocument: vendor.panDocument || null,
 aadhaarDocument: vendor.aadhaarDocument || null,
 panDocumentFile: null,
 aadhaarDocumentFile: null,
 bank: {
 bankName: vendor.bank?.bankName || "",
 accountHolder: vendor.bank?.accountHolder || "",
 accountNo: vendor.bank?.accountNo || "",
 confirmAccountNo: vendor.bank?.accountNo || "",
 ifsc: vendor.bank?.ifsc || "",
 },
 status: vendor.status || "Active",
 });
 }
 } catch (error) {
 console.error("Error fetching vendor:", error);
 swal("Error", "Failed to load vendor details", "error");
 navigate("/vendors");
 } finally {
 setFetching(false);
 }
 };

 const fetchCategories = async () => {
 try {
 const response = await api.get("/vendor-categories");
 if (response.data.success) {
 setCategories(response.data.data);
 }
 } catch (error) {
 console.error("Error fetching categories:", error);
 swal("Error", "Failed to load categories", "error");
 }
 };

 const handleChange = (e) => {
 let { name, value } = e.target;

 // Stop numbers in name fields
 if (name === "name" || name === "contactPerson") {
 value = value.replace(/[0-9]/g, "");
 }

if (name === "phone") {
 value = value.replace(/[^0-9+]/g, "");

 // allow + only at start
 if (value.includes("+")) {
 value = "+" + value.replace(/\+/g, "").replace(/^\+/, "");
 }
}

 // GST uppercase
 if (name === "gst") {
 value = value.toUpperCase();
 }

 if (name === "panNumber") {
 value = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
 }

 if (name === "aadhaarNumber") {
 value = value.replace(/\D/g, "");
 }

 setForm((prev) => ({ ...prev, [name]: value }));
};

const handleFileChange = (e) => {
 const { name, files } = e.target;
 setForm((prev) => ({
 ...prev,
 [name]: files?.[0] || null,
 }));
};

const handleBankChange = (e) => {
 let { name, value } = e.target;

 // Account numbers → digits only
 if (name === "accountNo" || name === "confirmAccountNo") {
 value = value.replace(/\D/g, "");
 }

 // IFSC uppercase
 if (name === "ifsc") {
 value = value.toUpperCase();
 }

 setForm((prev) => ({
 ...prev,
 bank: { ...prev.bank, [name]: value },
 }));
};

 const handleSubmit = async (e) => {
 e.preventDefault();

 // Validation
 if (!form.name)
 return swal("Warning", "Please enter vendor name", "warning");
 if (!form.category)
 return swal("Warning", "Please select a category", "warning");
 if (!form.contactPerson)
 return swal("Warning", "Please enter contact person", "warning");
 if (!form.email) return swal("Warning", "Please enter email", "warning");
 if (!form.phone)
 return swal("Warning", "Please enter phone number", "warning");
 if (!form.address)
 return swal("Warning", "Please enter address", "warning");
// PHONE VALIDATION
// PHONE VALIDATION
if (!phoneRegex.test(form.phone))
 return swal(
 "Warning",
 "Enter valid phone number with optional country code (e.g. +919876543210)",
 "warning"
 );

// GST VALIDATION (optional)
if (form.gst && !gstRegex.test(form.gst))
 return swal("Warning", "Invalid GST Number", "warning");

if (form.panNumber && !panRegex.test(form.panNumber))
 return swal("Warning", "Invalid PAN Number", "warning");

if (form.aadhaarNumber && !aadhaarRegex.test(form.aadhaarNumber))
 return swal("Warning", "Invalid Aadhaar Number", "warning");

// ACCOUNT NUMBER VALIDATION
if (form.bank.accountNo && !accountRegex.test(form.bank.accountNo))
 return swal("Warning", "Invalid Account Number", "warning");

// ACCOUNT MATCH VALIDATION
if (
 form.bank.accountNo &&
 form.bank.confirmAccountNo &&
 form.bank.accountNo !== form.bank.confirmAccountNo
)
 return swal("Warning", "Account numbers do not match!", "warning");

// IFSC VALIDATION
if (form.bank.ifsc && !ifscRegex.test(form.bank.ifsc))
 return swal("Warning", "Invalid IFSC Code", "warning");
 // BANK CONFIRM VALIDATION (only if filled)
 if (
 form.bank.accountNo ||
 form.bank.confirmAccountNo ||
 form.bank.bankName ||
 form.bank.ifsc
 ) {
 if (!form.bank.accountNo)
 return swal("Warning", "Please enter account number", "warning");
 if (!form.bank.confirmAccountNo)
 return swal("Warning", "Please confirm account number", "warning");
 if (form.bank.accountNo !== form.bank.confirmAccountNo)
 return swal("Warning", "Account numbers do not match!", "warning");
 }

 try {
 setLoading(true);
 const formData = new FormData();
 formData.append("name", form.name);
 formData.append("category", form.category);
 formData.append("contactPerson", form.contactPerson);
 formData.append("email", form.email);
 formData.append("phone", form.phone);
 formData.append("address", form.address);
 formData.append("state", form.state);
 formData.append("gst", form.gst || "");
 formData.append("panNumber", form.panNumber);
 formData.append("aadhaarNumber", form.aadhaarNumber);
 formData.append("bankName", form.bank.bankName || "");
 formData.append("accountHolder", form.bank.accountHolder || "");
 formData.append("accountNo", form.bank.accountNo || "");
 formData.append("ifsc", form.bank.ifsc || "");
 formData.append("status", form.status);

 if (form.panDocumentFile) {
 formData.append("panDocument", form.panDocumentFile);
 }

 if (form.aadhaarDocumentFile) {
 formData.append("aadhaarDocument", form.aadhaarDocumentFile);
 }

 const response = await api.patch(`/vendors/${id}`, formData);

 if (response.data.success) {
 swal("Success", "Vendor updated successfully!", "success");
 navigate("/vendors");
 }
 } catch (error) {
 console.error("Error updating vendor:", error);

 const message =
 error.response?.data?.error ||
 error.response?.data?.message ||
 "Failed to update vendor";

 if (message.includes("duplicate key") && message.includes("email")) {
 return swal("Error", "Email already exists", "error");
 }

 swal("Error", message, "error");
} finally {
 setLoading(false);
 }
 };

 if (fetching) {
 return (
 <Fragment>
 <PageTitle activeMenu="Edit Vendor" motherMenu="Vendor Management" />
 <Row>
 <Col lg={12}>
 <Card>
 <Card.Body>
 <div className="text-center py-5">
 <div className="spinner-border text-primary" role="status">
 <span className="visually-hidden">Loading...</span>
 </div>
 <p className="mt-3">Loading vendor details...</p>
 </div>
 </Card.Body>
 </Card>
 </Col>
 </Row>
 </Fragment>
 );
 }

 return (
 <Fragment>
 <PageTitle activeMenu="Edit Vendor" motherMenu="Vendor Management" />
 <Row>
 <Col lg={12}>
 <Card>
 <Card.Header className="d-flex justify-content-between align-items-center">
 <Card.Title>Edit Vendor</Card.Title>
 <Button variant="secondary" onClick={() => navigate("/vendors")}>
 <i className="fas fa-arrow-left me-2"></i>Back
 </Button>
 </Card.Header>

 <Card.Body>
 <Form onSubmit={handleSubmit}>
 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Vendor Name <span className="text-danger">*</span>
 </Form.Label>
 <Form.Control
 type="text"
 name="name"
 value={form.name}
 onChange={handleChange}
 placeholder="Enter vendor name"
 required
 />
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Category <span className="text-danger">*</span>
 </Form.Label>
 <Form.Select
 name="category"
 value={form.category}
 onChange={handleChange}
 required
 >
 <option value="">Select Category</option>
 {categories.map((cat) => (
 <option key={cat._id} value={cat._id}>
 {cat.name}
 </option>
 ))}
 </Form.Select>
 <Form.Text className="text-muted">
 Select vendor category
 </Form.Text>
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Contact Person <span className="text-danger">*</span>
 </Form.Label>
 <Form.Control
 type="text"
 name="contactPerson"
 value={form.contactPerson}
 onChange={handleChange}
 placeholder="Enter contact person name"
 required
 />
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Email <span className="text-danger">*</span>
 </Form.Label>
 <Form.Control
 type="email"
 name="email"
 value={form.email}
 onChange={handleChange}
 placeholder="Enter email address"
 required
 />
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Phone <span className="text-danger">*</span>
 </Form.Label>
 <Form.Control
 type="text"
 name="phone"
 maxLength="16"
 value={form.phone}
 onChange={handleChange}
/>
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>GST / Tax Number</Form.Label>
 <Form.Control
 type="text"
 name="gst"
 maxLength="15"
 value={form.gst}
 onChange={handleChange}
/>
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 PAN Number
 </Form.Label>
 <Form.Control
 type="text"
 name="panNumber"
 maxLength="10"
 value={form.panNumber}
 onChange={handleChange}
 placeholder="ABCDE1234F"
 />
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Aadhaar Number
 </Form.Label>
 <Form.Control
 type="text"
 name="aadhaarNumber"
 maxLength="12"
 value={form.aadhaarNumber}
 onChange={handleChange}
 placeholder="123412341234"
 />
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>PAN Card Upload</Form.Label>
 <Form.Control
 type="file"
 name="panDocumentFile"
 accept=".pdf,.jpg,.jpeg,.png"
 onChange={handleFileChange}
 />
 <Form.Text className="text-muted d-block">
 {form.panDocument?.fileUrl ? (
 <>
 Current file:{" "}
 <a
 href={form.panDocument.fileUrl}
 target="_blank"
 rel="noreferrer"
 >
 {form.panDocument.fileName || "View PAN document"}
 </a>
 </>
 ) : (
 "No PAN document uploaded yet"
 )}
 </Form.Text>
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Aadhaar Card Upload</Form.Label>
 <Form.Control
 type="file"
 name="aadhaarDocumentFile"
 accept=".pdf,.jpg,.jpeg,.png"
 onChange={handleFileChange}
 />
 <Form.Text className="text-muted d-block">
 {form.aadhaarDocument?.fileUrl ? (
 <>
 Current file:{" "}
 <a
 href={form.aadhaarDocument.fileUrl}
 target="_blank"
 rel="noreferrer"
 >
 {form.aadhaarDocument.fileName || "View Aadhaar document"}
 </a>
 </>
 ) : (
 "No Aadhaar document uploaded yet"
 )}
 </Form.Text>
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={12}>
 <Form.Group className="mb-3">
 <Form.Label>
 Address <span className="text-danger">*</span>
 </Form.Label>
 <Form.Control
 as="textarea"
 rows={3}
 name="address"
 value={form.address}
 onChange={handleChange}
 placeholder="Enter complete address"
 required
 />
 </Form.Group>
 </Col>
 </Row>
 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 State <span className="text-danger">*</span>
 </Form.Label>
 <Form.Select
 name="state"
 value={form.state}
 onChange={handleChange}
 required
 >
 <option value="">Select State</option>
 {form.state && !INDIAN_STATES.includes(form.state) && (
 <option value={form.state}>{form.state}</option>
 )}
 {INDIAN_STATES.map((stateName) => (
 <option key={stateName} value={stateName}>
 {stateName}
 </option>
 ))}
 </Form.Select>
 </Form.Group>
 </Col>
 </Row>
 {/* =========================
 BANK DETAILS
 ========================= */}
 <Row>
 <Col md={3}>
 <Form.Group className="mb-3">
 <Form.Label>Bank Name</Form.Label>
 <Form.Control
 type="text"
 name="bankName"
 value={form.bank.bankName}
 onChange={handleBankChange}
 placeholder="Bank Name"
 />
 </Form.Group>
 </Col>

 <Col md={3}>
 <Form.Group className="mb-3">
 <Form.Label>Account Holder Name</Form.Label>
 <Form.Control
 type="text"
 name="accountHolder"
 value={form.bank.accountHolder}
 onChange={handleBankChange}
 placeholder="Account Holder Name"
 />
 </Form.Group>
 </Col>

 <Col md={3}>
 <Form.Group className="mb-3">
 <Form.Label>Account No</Form.Label>
 <Form.Control
 type="text"
 name="accountNo"
 maxLength="18"
 value={form.bank.accountNo}
 onChange={handleBankChange}
/>
 </Form.Group>
 </Col>

 <Col md={3}>
 <Form.Group className="mb-3">
 <Form.Label>Confirm Account No</Form.Label>
 <Form.Control
 type="text"
 name="confirmAccountNo"
 maxLength="18"
 value={form.bank.confirmAccountNo}
 onChange={handleBankChange}
/>
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={3}>
 <Form.Group className="mb-3">
 <Form.Label>IFSC Code</Form.Label>
 <Form.Control
 type="text"
 name="ifsc"
 maxLength="11"
 value={form.bank.ifsc}
 onChange={handleBankChange}
/>
 </Form.Group>
 </Col>
 </Row>

 <Form.Text className="text-muted mb-3 d-block">
 Enter bank name, account number, IFSC code, etc.
 </Form.Text>

 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Status</Form.Label>
 <Form.Select
 name="status"
 value={form.status}
 onChange={handleChange}
 >
 {statuses.map((status, i) => (
 <option key={i} value={status}>
 {status}
 </option>
 ))}
 </Form.Select>
 </Form.Group>
 </Col>
 </Row>

 <div className="d-flex gap-2 mt-3">
 <Button type="submit" variant="primary" disabled={loading}>
 {loading ? (
 <>
 <span className="spinner-border spinner-border-sm me-2"></span>
 Updating...
 </>
 ) : (
 <>
 <i className="fas fa-save me-2"></i>Update Vendor
 </>
 )}
 </Button>

 <Button
 type="button"
 variant="danger"
 onClick={() => navigate("/vendors")}
 disabled={loading}
 >
 <i className="fas fa-times me-2"></i>Cancel
 </Button>
 </div>
 </Form>
 </Card.Body>
 </Card>
 </Col>
 </Row>
 </Fragment>
 );
};

export default VendorEdit;
